import { render } from "./LesBibliothequesPage.vue?vue&type=template&id=505ddf85"
import script from "./LesBibliothequesPage.vue?vue&type=script&lang=js"
export * from "./LesBibliothequesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__